module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";
	fox.registerWidget('Faq_Question', {
		
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				widgets: {
					sendApi: {
						widget: 'Api',
						method: 'faq.sendQuestion'
					},

					captcha: {
						widget: 'Captcha',
						container: '.cp'
					}
				},

				handleWom: {
					succesSending: {
						widget: '#sendApi',
						event: 'success',
						callback: 'showSuccess'
					},
					errorSending: {
						widget: '#sendApi',
						event: 'failure',
						callback: '_handleError'
					}
				},

				handleDom: {
					send: {
						target: '.send',
						event: 'click',
						callback: '_submit'
					},
					input: {
						target: '.fields2send',
						event: 'input',
						callback: '_hideError'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		_collectData: function () {
			var result = {};
			
			var fields = fox.dom.select('.fields2send', this.element[0]);
			var captchaId = this.rwom1('#captcha').captchaId;

			fox.each(fields, function (field) {
				if (field.value && field.value.length) {
					result[field.name] = field.value;
				} else {
					this._toggleError(field.name, true);
				}				
			}, this);

			if (captchaId) {
				result.captchaId = captchaId;
			}
			
			return result;
		},

		_submit: function () {
			if (!fox.site.member) {
				var check = fox.dom.sel1('#consent_tos');
				if (check._node.checked) {
					this.send();
					return true;
				} else {
					check.addClass('error');
					fox.site.wait(check, 'click', function (elt) {
						elt.removeClass('error');
					});
					return false;
				}
			}
			this.send();
		},

		send: function () {
			this.data = this._collectData();
			var api = this.rwom1('#sendApi');

			api.send(this.data, false);
		},

		_toggleError: function (name, state) {
			var field = fox.dom.selectFirst('[name="' + name + '"]', this.element[0]);

			if (!field) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('error', field);
		},

		_hideError: function (el) {
			this._toggleError(el.name, false);
		},

		showSuccess: function () {
			fox.each(this.data, function (val, key) {
				this._toggleError(key, false);
			}, this);

			var block = fox.dom.selectFirst('.fqb-content.form', this.element[0]);

			fox.dom.addClass('success', block);

			window.setTimeout(fox.bind(function () {
				fox.dom.removeClass('show', block);
			}, this), 3000);

			this.dispatchEvent('success');
		},

		_handleError: function (response) {
			if (response.answer.code === 2) {
				this._toggleError('captcha', true);
			}
		}

	}, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/widget/sitepage/faq/question.js
// module id = 497
// module chunks = 2